import { useEffect, useRef } from 'react'

/**
 * ⌘S / Ctrl-S saves the mounted editing surface (Charles, 2026-08-05) —
 * same as pressing its Save button. The browser's own save-page dialog is
 * suppressed whenever a surface with a save handler is open. The handler
 * ref keeps the listener stable across renders, so fresh state is read
 * without re-binding.
 */
export default function useSaveShortcut(onSave) {
  const ref = useRef(onSave)
  ref.current = onSave
  useEffect(() => {
    function onKey(e) {
      if (!(e.metaKey || e.ctrlKey) || e.altKey || e.shiftKey) return
      if (String(e.key).toLowerCase() !== 's') return
      e.preventDefault()
      ref.current?.()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])
}
